import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParameters } from '@web/utils';
import { useReatailersQueryQuery } from '@/pages/FarmerPages/FarmersHomePage/retailers.generated';
import { useAppSelector } from '@/store/hooks';
import {
  getSelectedRetailerId,
  setSelectedRetailerId,
} from '@/utils/retailerSelection';

const useSetInitialRetailer = () => {
  const { retailerId } = useParameters<{ retailerId?: string }>();
  const navigate = useNavigate();
  const [{ data }] = useReatailersQueryQuery({});
  const { isRetrieved: userRetreived } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (data?.retailers.length === 0) {
      setSelectedRetailerId('');
    }
    if (data?.retailers?.length && data.retailers.length > 0 && !retailerId) {
      const selectedRetailerId = getSelectedRetailerId();
      if (selectedRetailerId) {
        navigate(`/${selectedRetailerId}`);
      } else {
        const defaultRetailerId = data?.retailers?.[0]?.id;
        if (defaultRetailerId) {
          setSelectedRetailerId(defaultRetailerId);
          navigate(`/${defaultRetailerId}`);
        }
      }
    }
  }, [data?.retailers, navigate, retailerId, userRetreived]);
};

export default useSetInitialRetailer;
